module.exports = __webpack_public_path__ + "img/health38_7-9-2021.a8d64cce.jpg";